module.exports = __webpack_public_path__ + "img/bg.0d95f688.png";